window.showToast = function (message, type = "success") {
  const container = document.getElementById("toast-container-bs");
  if (!container) return;
  const toast = document.createElement("div");
  const isWishlist = message.toLowerCase().includes("wishlist");
  const wishlistClass = isWishlist ? "has-heart" : "";
  toast.className = `toast-message toast-${type} ${wishlistClass}`;
  const icon = type === "success" ? "✓" : "!";
  toast.innerHTML = `<span class="toast-icon">${icon}</span><span>${message}</span>`;
  container.appendChild(toast);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateStack();
    });
  });
  setTimeout(() => {
    toast.classList.add("toast-fade-out");
    setTimeout(() => {
      toast.remove();
      updateStack();
    }, 500);
  }, 3000);
};
function updateStack() {
  const activeToasts = Array.from(
    document.querySelectorAll(".toast-message:not(.toast-fade-out)"),
  ).reverse();
  activeToasts.forEach((toast, index) => {
    toast.classList.remove("stack-1", "stack-2", "stack-3");
    if (index === 0) {
      toast.classList.add("stack-1");
    } else if (index === 1) {
      toast.classList.add("stack-2");
    } else if (index === 2) {
      toast.classList.add("stack-3");
    } else {
      toast.style.opacity = "0";
      toast.style.pointerEvents = "none";
    }
  });
}
(function () {

  const header = document.getElementById("site-header");

  if (!header) return;

  let ticking = false;

  window.addEventListener("scroll", function () {

    if (!ticking) {

      window.requestAnimationFrame(function () {

        header.classList.toggle(
          "scrolled",
          window.scrollY > 50
        );

        ticking = false;

      });

      ticking = true;

    }

  }, { passive: true });

})();
(function () {
  function refreshHeaderCart() {
    fetch("/cart.js?v=" + new Date().getTime())
      .then((res) => res.json())
      .then((cart) => {
        let countElement = document.querySelector(".cart-count");
        const cartLink = document.querySelector(".header-cart-icon");
        if (!cartLink) return;
        if (cart.item_count > 0) {
          if (countElement) {
            countElement.textContent = cart.item_count;
            countElement.style.display = "flex";
          } else {
            cartLink.insertAdjacentHTML(
              "beforeend",
              `<span class="cart-count">${cart.item_count}</span>`,
            );
          }
        } else if (countElement) {
          countElement.style.display = "none";
        }
      });
  }
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      if (response.url.includes("/cart/add")) {
        refreshHeaderCart();
        if (typeof loadCart === "function") loadCart();
       if (typeof handleFreebie === "function" && window.location.pathname !== '/cart') {
          handleFreebie();
        }
        if (typeof openDrawer === "function" && window.location.pathname !== '/cart') {
          setTimeout(() => {
            loadCart();
            openDrawer();
          }, 300);
        }

        if (response.ok) {
         showToast("Product Added To Bag!", "success");
          const cartIcon = document.querySelector(".header-cart-icon");
          if (cartIcon) {
            cartIcon.classList.add("cart-bounce");
            setTimeout(() => cartIcon.classList.remove("cart-bounce"), 400);
          }
        } else {
          showToast("Could not add to Bag", "error");
        }
      }

      
      if (
        response.url.includes('/cart/change') ||
        response.url.includes('/cart/update')
      ) {

        refreshHeaderCart();

        if (typeof loadCart === "function") {
          loadCart();
        }

       if (typeof handleFreebie === "function" && window.location.pathname !== '/cart') {
        handleFreebie();
      }
      }
      return response;
    });
  };
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("button") || e.target.closest("a");
    if (
      btn &&
      (btn.name === "plus" ||
        btn.name === "minus" ||
        (btn.href && btn.href.includes("change?")))
    ) {
      setTimeout(refreshHeaderCart, 800);
    }
  });
})();
function initMenu() {
  const menuBtn = document.querySelector(".mobile-menu-trigger");
  const closeBtn = document.querySelector(".close-drawer");
  const overlay = document.querySelector(".mobile-drawer-overlay");
  const drawer = document.querySelector(".mobile-drawer");
  if (!menuBtn || !closeBtn || !overlay || !drawer) return;
  function toggleMenu() {
    drawer.classList.toggle("active");
    overlay.classList.toggle("active");
    document.body.classList.toggle("menu-open");
  }
  menuBtn.addEventListener("click", toggleMenu);
  closeBtn.addEventListener("click", toggleMenu);
  overlay.addEventListener("click", toggleMenu);
}
function initScrollTop() {
  const scrollTopBtn = document.querySelector(".scroll-top");
  const progressPath = document.querySelector(".scroll-top path");
  if (!scrollTopBtn || !progressPath) return;
  const pathLength = progressPath.getTotalLength();
  progressPath.style.strokeDasharray = pathLength + " " + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  const updateProgress = () => {
    const scroll = window.scrollY;
    const height = Math.max(
      document.documentElement.scrollHeight - window.innerHeight,
      1,
    );
    const progress = pathLength - (scroll * pathLength) / height;
    progressPath.style.strokeDashoffset = progress;
    if (scroll > 50) {
      scrollTopBtn.classList.add("active-progress");
    } else {
      scrollTopBtn.classList.remove("active-progress");
    }
  };
  window.addEventListener("scroll", updateProgress);
  scrollTopBtn.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  updateProgress();
}

document.addEventListener("DOMContentLoaded", function () {
  updateWishlistBadge();
  if (document.querySelector(".wishlist-page-wrapper")) {
    renderWishlist();
  }
});
function addToBag(variantId, btn, e, handle) {
  navigator.vibrate && navigator.vibrate([20, 40, 20]);
  if (btn) btn.innerText = "ADDING...";
  if (e) triggerLuxuryAnimation(e);
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Add failed");
      return res.json();
    })
    .then(() => {
      if (typeof loadCart === "function") loadCart();
      if (handle) {
        removeWish(handle);
      }
      if (typeof openDrawer === "function") {
  setTimeout(() => {
    loadCart();   
    openDrawer(); 
  }, 300);
}
      if (btn) {
        btn.innerText = "ADDED!";
      }
    })
    .catch(() => {
      if (btn) btn.innerText = "ADD TO BAG";
      showToast("Could not add to Bag", "error");
    });
}
$(document).ready(function () {

  function getWishlist() {
    return JSON.parse(localStorage.getItem("user_wishlist")) || [];
  }
  $(document).ready(syncWishlistIcons);
  $(document).on("shopify:section:load", syncWishlistIcons);
});


document.addEventListener("click", function (e) {
  const cartBtn =
    e.target.closest(".header-cart-icon") ||
    e.target.closest('a[href="/cart"]');
  if (cartBtn) {
    if (!cartBtn.classList.contains("mobile-nav-link")) {
      e.preventDefault();
      if (typeof openDrawer === "function") {
        loadCart();
        openDrawer();
      }
    }
  }
});
document.addEventListener("click", function (e) {
  const btn = e.target.closest('[type="submit"]');
  if (!btn) return;
  btn._lastClickX = e.clientX;
  btn._lastClickY = e.clientY;
  navigator.vibrate && navigator.vibrate([20, 40, 20]);
});
document.addEventListener("submit", function (e) {
  const form = e.target;
  if (!form.action || !form.action.includes("/cart/add")) return;
  e.preventDefault();
  const submitBtn = form.querySelector('[type="submit"]');
  if (!submitBtn) return;
  if (submitBtn.classList.contains("adding")) return;
  submitBtn.classList.add("adding");
  submitBtn.innerHTML = `
    <span class="btn-icon">${submitBtn.querySelector(".btn-icon").innerHTML}</span>
    Adding...
  `;
  const fakeEvent = {
    clientX: submitBtn._lastClickX || 0,
    clientY: submitBtn._lastClickY || 0,
  };
  triggerLuxuryAnimation(fakeEvent);
  const formData = new FormData(form);
  fetch("/cart/add.js", { method: "POST", body: formData })
    .then((res) => res.json())
    .then(() => {
      submitBtn.classList.remove("adding");
      submitBtn.classList.add("added");
      submitBtn.innerHTML = `
      <span class="btn-icon">${submitBtn.querySelector(".btn-icon").innerHTML}</span>
      Added ✓
    `;
      setTimeout(() => {
        submitBtn.classList.remove("added");
        submitBtn.innerHTML = `
        <span class="btn-icon">${submitBtn.querySelector(".btn-icon").innerHTML}</span>
        Add to Bag
      `;
      }, 2000);
    })
    .finally(() => {
      setTimeout(() => {
        if (submitBtn) submitBtn.disabled = !1;
      }, 1000);
    });
});
function triggerLuxuryAnimation(e) {
  const cartTarget = document.querySelector(".header-cart-icon");
  if (!cartTarget) return;
  const rect = cartTarget.getBoundingClientRect();
  const targetX = rect.left + rect.width / 2;
  const targetY = rect.top + rect.height / 2;
  const colors = ["#c9a84c", "#e8c96a", "#ffffff"];
  const layer = document.getElementById("particles-layer");
  if (layer) {
    for (let i = 0; i < 12; i++) {
      const p = document.createElement("div");
      p.className = "particle";
      const angle = (Math.PI * 2 * i) / 12;
      const dist = 40 + Math.random() * 40;
      p.style.cssText = `
        left:${e.clientX}px; top:${e.clientY}px;
        width:${3 + Math.random() * 3}px; height:${3 + Math.random() * 3}px;
        background:${colors[Math.floor(Math.random() * colors.length)]};
        --dx:${Math.cos(angle) * dist}px; --dy:${Math.sin(angle) * dist}px;
      `;
      layer.appendChild(p);
      p.addEventListener("animationend", () => p.remove());
    }
  }
  const ring = document.createElement("div");
  ring.className = "ring-burst";
  ring.style.cssText = `left:${e.clientX}px; top:${e.clientY}px;`;
  document.body.appendChild(ring);
  ring.addEventListener("animationend", () => ring.remove());
  const fly = document.createElement("div");
  fly.className = "fly-bag-anim";
  fly.innerHTML = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" stroke="#183867" stroke-width="1.5"/>
  <line x1="3" y1="6" x2="21" y2="6" stroke="#183867" stroke-width="1.5"/>
  <path d="M16 10a4 4 0 0 1-8 0" stroke="#183867" stroke-width="1.5"/>
</svg>
`;
  const diffX = targetX - e.clientX;
  const diffY = targetY - e.clientY;
  fly.style.cssText = `
    left:${e.clientX - 12}px; top:${e.clientY - 12}px;
    --fly-x1:${diffX * 0.4}px; --fly-y1:${diffY * 0.4 - 80}px;
    --fly-x2:${diffX}px; --fly-y2:${diffY}px;
  `;
  document.body.appendChild(fly);
  fly.addEventListener("animationend", () => fly.remove());
}
function createRipple(e, el) {
  const circle = document.createElement("span");
  circle.className = "ripple";
  const rect = el.getBoundingClientRect();
  const size = 60;
  circle.style.width = size + "px";
  circle.style.height = size + "px";
  circle.style.left = e.clientX - rect.left - size / 2 + "px";
  circle.style.top = e.clientY - rect.top - size / 2 + "px";
  el.appendChild(circle);
  setTimeout(() => circle.remove(), 600);
}
function createFloatingHearts(el) {
  for (let i = 0; i < 3; i++) {
    const h = document.createElement("div");
    h.className = "float-heart";
    h.innerHTML = "❤️";
    h.style.left = 20 + Math.random() * 10 + "px";
    h.style.top = "10px";
    el.appendChild(h);
    setTimeout(() => h.remove(), 1000);
  }
}
function enableToastInteractions(toast) {
  let startX = 0;
  let currentX = 0;
  let isDragging = !1;
  toast.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isDragging = !0;
    toast.classList.add("swiping");
  });
  toast.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX - startX;
    toast.style.transform = `translateX(${currentX}px)`;
    toast.style.opacity = 1 - Math.abs(currentX) / 150;
  });
  toast.addEventListener("touchend", () => {
    isDragging = !1;
    toast.classList.remove("swiping");
    if (Math.abs(currentX) > 100) {
      removeToast(toast);
    } else {
      resetToast(toast);
    }
  });
  toast.addEventListener("mousedown", (e) => {
    startX = e.clientX;
    isDragging = !0;
    toast.classList.add("swiping");
  });
  window.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    currentX = e.clientX - startX;
    toast.style.transform = `translateX(${currentX}px)`;
    toast.style.opacity = 1 - Math.abs(currentX) / 150;
  });
  window.addEventListener("mouseup", () => {
    if (!isDragging) return;
    isDragging = !1;
    toast.classList.remove("swiping");
    if (Math.abs(currentX) > 100) {
      removeToast(toast);
    } else {
      resetToast(toast);
    }
  });
  setTimeout(() => {
    removeToast(toast);
  }, 3000);
}
function removeToast(toast) {
  toast.style.animation = "toastOut 0.4s forwards";
  setTimeout(() => toast.remove(), 400);
}
function resetToast(toast) {
  toast.style.transform = "";
  toast.style.opacity = "";
}
function createFloatingHearts(target) {
  const $icon = $(target);
  for (let i = 0; i < 5; i++) {
    const heart = $('<span class="floating-heart">❤️</span>');
    const offsetX = (Math.random() - 0.5) * 30;
    const offsetY = -30 - Math.random() * 20;
    $icon.append(heart);
    heart.css({
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: `translate(-50%, -50%)`,
      fontSize: "12px",
      pointerEvents: "none",
      opacity: 0,
    });
    heart.animate(
      {
        left: `+=${offsetX}px`,
        top: `+=${offsetY}px`,
        opacity: 1,
        fontSize: "16px",
      },
      300,
      "swing",
      function () {
        heart.animate({ opacity: 0, top: `+=10` }, 300, function () {
          heart.remove();
        });
      },
    );
  }
} 
document.addEventListener('DOMContentLoaded', () => {
  const reviewRows = document.querySelectorAll('.product-review-row');
  
  reviewRows.forEach((row) => {
    const productId = row.dataset.productId;
    const handle = row.dataset.handle; 
    fetch(`https://phpstack-1307820-6356281.cloudwaysapps.com/reviews.php?product_id=${productId}&handle=${handle}`)
      .then((res) => res.json())
      .then((data) => {
        const reviews = (data.reviews || []).filter((r) => r.published && !r.hidden);
        
        if (reviews.length === 0) {
          row.querySelector('.rating-value').innerText = 'No reviews';
          const btn = row.querySelector('.see-reviews-link');
          if (btn) btn.style.display = 'none';
          row.style.opacity = '1';
          return;
        }

        let total = 0;
        reviews.forEach((r) => (total += parseFloat(r.rating) || 0));
        const avg = (total / reviews.length).toFixed(1);

        row.querySelector('.rating-value').innerText = avg;
        row.style.opacity = '1';
      })
      .catch(() => {
        row.style.opacity = '1';
      });
  });
});

function initAll() {
  initMenu();
  initScrollTop(); 
}
document.addEventListener("DOMContentLoaded", initAll);
document.addEventListener("shopify:section:load", initAll);
